import createCrudVuexModule from "@/store/crud";

export const physicalArchiveCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/physical-archive-category",
});

export const workspacePhysicalArchiveCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/physical-archive-category",
});

export const managementPhysicalArchiveCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/physical-archive-category",
});

// ----------------------------------------------

export const physicalArchive = createCrudVuexModule({
  namespaced: true,
  path: "/library/physical-archive",
});

export const workspacePhysicalArchive = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/physical-archive",
});

export const managementPhysicalArchive = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/physical-archive",
});

// ----------------------------------------------

export const electronicArchive = createCrudVuexModule({
  namespaced: true,
  path: "/library/electronic-archive",
});

export const workspaceElectronicArchive = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/electronic-archive",
});

export const managementElectronicArchive = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/electronic-archive",
});
// ----------------------------------------------

export const electronicArchiveCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/electronic-archive-category",
});

export const workspaceElectronicArchiveCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/electronic-archive-category",
});

export const managementElectronicArchiveCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/electronic-archive-category",
});
